import { localURL } from "../config/urls";

const imgconvert = (x) => {
  return `${localURL}${x}`;
};
export { imgconvert };
